// extracted by mini-css-extract-plugin
module.exports = {"main":"SignDiv_main__1jtTf","hidden":"SignDiv_hidden__1oLfo","nonActive":"SignDiv_nonActive__ZXtv_"};